import React from 'react';
import type ServicedeskReportsWorkloadType from '@atlassian/jira-spa-apps-servicedesk-reports-workload/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { WORKLOAD_ROUTE_SUFFIX } from '../../common/constants.tsx';

export const LazyServicedeskReportsWorkload = lazyForPaint<typeof ServicedeskReportsWorkloadType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-reports-workload", jiraSpaEntry: "async-servicedesk-reports-workload" */ '@atlassian/jira-spa-apps-servicedesk-reports-workload'
			),
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskReportsWorkload}
		pageId={`spa-apps/servicedesk${WORKLOAD_ROUTE_SUFFIX}}`}
		shouldShowSpinner
	/>
);
